__turbopack_context__.v({
  "button": "ArticleGallery-module__jCuN2a__button",
  "caption": "ArticleGallery-module__jCuN2a__caption",
  "controls": "ArticleGallery-module__jCuN2a__controls",
  "gallery": "ArticleGallery-module__jCuN2a__gallery",
  "imageFrame": "ArticleGallery-module__jCuN2a__imageFrame",
  "position": "ArticleGallery-module__jCuN2a__position",
  "slide": "ArticleGallery-module__jCuN2a__slide",
  "viewport": "ArticleGallery-module__jCuN2a__viewport",
});
